import { CheckoutEnvironment } from '../app/interfaces/environment';

export const checkoutDevConfig: CheckoutEnvironment = {
  bemobi: {
    iframeBaseUrl: 'https://smart-checkout-dev.bemobi.com/checkout',
    allowedOrigins: [
      'https://smart-checkout-dev.bemobi.com',
      'https://smart-checkout.bemobi.com'
    ]
  },
  shopCheckoutMock: {
    enabled: false,
    strategy: 'Bemobi'
  }
};

export const checkoutProdConfig: CheckoutEnvironment = {
  bemobi: {
    iframeBaseUrl: 'https://smart-checkout.bemobi.com/checkout',
    allowedOrigins: [
      'https://smart-checkout-dev.bemobi.com',
      'https://smart-checkout.bemobi.com'
    ]
  },
  shopCheckoutMock: {
    enabled: false,
    strategy: 'Bemobi'
  }
};
